module.exports = __webpack_public_path__ + "img/12947a2c792797f5dd16d33f00a7fdb1.png";